import React, { Component } from "react";

//redux
import { connect } from "react-redux";
import { getFeaturedJobAction } from "store/Home";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";
import { MapPin, ChevronRight, ChevronLeft } from "react-feather";
// import Swiper core and required modules
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import { Bookmark } from "react-feather";

import { AddBookmarkACTION } from "store/Bookmark";
import defaultjob from "assets/img/defaultjob.png";
import moment from "moment";
import { Link } from "react-router-dom";

// install Swiper modules
SwiperCore.use([Pagination, Navigation]);

class FeaturedJobClass extends Component {
  constructor(props) {
    super(props);
    this.navigationPrevRef = React.createRef();
    this.navigationNextRef = React.createRef();

    this.state = { isBookmarked: false };
  }
  addDefaultSrc(ev) {
    ev.target.src = defaultjob;
  }

  async bookmark(ev, id) {
    this.setState((state) => {
      // Important: read `state` instead of `this.state` when updating.
      return { isBookmarked: !state.isBookmarked };
    });
    let Bookmark = document.querySelector(`#Bookmark${id}`);
    Bookmark.classList.replace("text-white", "bookmarked");
    let payload = {
      user_id: this.props.Auth.MGID,
      job_id: id,
    };
    let response = await this.props.AddBookmark(payload);
    // if(response.ResponseCode == 100){
    //   ev.className = "bookmarked"
    // }
    // else{
    //   ev.className = "text-white"
    // }
  }
  render() {
    return (
      <>
        <div className="flex justify-between items-center mt-16  mb-8">
          <h2 className="fsize28 sm-fsize16 font-bold">FEATURED JOBS</h2>
          <div className="flex cursor-pointer">
            <ChevronLeft
              width="30px"
              height="30px"
              className="trend-left-i mr-2 "
              ref={this.navigationPrevRef}
            />
            {/* swiper-button-prev swiper-button-next*/}
            <ChevronRight
              width="30px"
              height="30px"
              className="trend-right-i "
              ref={this.navigationNextRef}
            />
          </div>
        </div>

        <Swiper
          navigation
          breakpoints={{
            1366: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
            991: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
            420: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            375: {
              slidesPerView: 2,
              spaceBetween: 15,
            },
            320: {
              slidesPerView: 1,
              spaceBetween: 15,
            },
          }}
          spaceBetween={30}
          slidesPerGroup={4}
          // loop={true}
          loopFillGroupWithBlank={true}
          pagination={{
            clickable: true,
          }}
          navigation={false}
          className="mySwiper swiperpagination-dot"
        >
          {this.props.featuredjobs.ResponseCode === 100 ? (
            <>
              {this.props.featuredjobs.Data &&
                this.props.featuredjobs.Data.map((datajobs, index) => {
                  return (
                    <div>
                      <SwiperSlide className="shadow-lg rounded-12px mb-4 showcard" key={index}>
                        <div className="img__wrap w-full">
                          <div>
                            <div className="relative">
                              {/* <img
                              src={
                                process.env.REACT_APP_IMAGE_BASE_MG + '/'+ datajobs.f_path                             }
                                      
                                className="w-full rounded-t-lg cust-h210px"
                                alt="banner-img "
                               /> */}
                              <img
                                onError={this.addDefaultSrc}
                                src={
                                  process.env.REACT_APP_IMAGE_BASE_MG +
                                  "/" +
                                  datajobs.f_path
                                }
                                className="w-full rounded-t-12px cust-h210px object-fill"
                                alt="banner-img "
                              />
                              {/* process.env.REACT_APP_IMAGE_BASE_MG + datajobs.f_path */}
                              <div className="absolute bookmark-parent bookmark-icon-w text-white rounded-full cursor-pointer">
                                <Bookmark
                                  id={`Bookmark${datajobs.f_jobId}`}
                                  width="18px"
                                  height="18px"
                                  className="text-white"
                                  onClick={(e) =>
                                    this.bookmark(e, datajobs.f_jobId)
                                  }
                                />
                              </div>
                            </div>
                            <div className="lg:p-4 md:p-4 lg:p-4  md:p-4 p-3">
                              <p className="text-black  sm-fsize12 sm-font-semibold line-clamp-1	font-medium fsize18 ">
                                {datajobs.f_title}
                              </p>
                            </div>
                          </div>
                          <div className="img__description_layer">
                            <h1 className="img__description trend-hover-h truncate">
                              {datajobs.JobTitle}
                            </h1>
                            <div className="lg:p-4  md:p-4 p-2">
                              <p className="text-black font-bold  sm-fsize12 line-clamp-1 fsize18">
                                {datajobs.f_title}
                              </p>
                            </div>

                            <p className="text-muted-1 ">
                              Required Experience:
                              <span className="text-black font-semibold">
                                {datajobs.Experience}
                              </span>
                            </p>
                            <p className="text-muted-1 ">
                              Education:{" "}
                              <span className="text-black font-semibold">
                                {datajobs.Education || "ANY"}
                              </span>
                            </p>
                            <div className="flex justify-around lg:mt-4 md:mt-4 mt-2">
                              <div className="flex items-center">
                                <MapPin
                                  width="15px"
                                  height="15px"
                                  className="text-orange1"
                                />
                                <p className="text-muted-1 ml-2">
                                  {datajobs.Location || "India"}
                                </p>
                              </div>

                              <p className="text-muted-1 ">
                                {moment(datajobs.f_createdDate).fromNow()}
                              </p>
                            </div>

                            <div className="flex justify-center">
                              <Link
                                to={{
                                  pathname:
                                    process.env.PUBLIC_URL +
                                    "/Career/job-details/" +
                                    datajobs.f_jobId,
                                  state: datajobs.f_jobId,
                                }}
                                class="cust-trendapply-btn flex"
                              >
                                {" "}
                                APPLY NOW
                              </Link>
                              {/* <button className="cust-trendapply-btn flex">
                              APPLY NOW
                            </button> */}
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    </div>
                  );
                })}
            </>
          ) : (
            <div>{this.props.featuredjobs.ResponseMessage}</div>
          )}
        </Swiper>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    featuredjobs: state.Home.home.FEATUREDJOB,
    Auth: state.Auth.user,
    // mgid :state.Auth.user.MGID,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    AddBookmark: async (payload) => await dispatch(AddBookmarkACTION(payload)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturedJobClass);
